
	frappe.templates['form_sidebar'] = `<div class="flex justify-between sidebar-image-section sidebar-section hide">
	<div class="sidebar-image-wrapper">
		<img class="sidebar-image">
		<div class="sidebar-standard-image">
			<div class="standard-image"></div>
		</div>
		{% if can_write %}
		<div class="sidebar-image-actions">
			<div class="sidebar-image-upload-hint">
				<svg class="es-icon icon-sm"><use href="#es-line-camera"></use></svg>
			</div>
			<a class="sidebar-image-remove">
				<svg class="icon icon-sm"><use href="#icon-x"></use></svg>
			</a>
		</div>
		{% endif %}
	</div>
	{% if image_field %}
	<div class="align-items-baseline flex form-stats-likes">
		<div class="form-title-edit"></div>
		<div class="form-print"></div>
		<span class="liked-by like-action d-flex align-items-center">
			<svg class="icon icon-sm like-icon pointer">
				<use href="#icon-heart"></use>
			</svg>
		</span>
	</div>
	{% endif %}
</div>
<div class="sidebar-section sidebar-meta-details border-bottom">
	<div class="flex justify-between overflow-hidden">
		<div class="ellipsis">
			{% let title = frm.get_title(); %}
			<div class="form-details flex justify-between form-title-text"  data-copy="{%= frappe.utils.escape_html(frappe.utils.html2text(title)) %}">
				<span class="bold ellipsis mr-3 text-medium">{%= frappe.utils.escape_html(frappe.utils.html2text(title)) %}</span>
			</div>
			{% if frm.meta.beta %}
			<div class="pt-1">
				<label class="indicator-pill yellow mb-0" title="{{ __("This feature is brand new and still experimental") }}">{{ __("Experimental") }}</label>
			</div>
			{% endif %}
			{% if (title && title !== frm.doc.name) { %}
			<div class="form-name-container mt-1 flex justify-between form-name-copy" data-copy="{%= frappe.utils.escape_html(frappe.utils.html2text(frm.doc.name)) %}" title="{%= frappe.utils.escape_html(frappe.utils.html2text(frm.doc.name)) %}" >
				<span class="ellipsis mr-3">{%= frappe.utils.escape_html(frappe.utils.html2text(frm.doc.name)) %}</span>
			</div>
			{% } %}
		</div>
		{% if not image_field %}
		<div class="align-items-baseline flex form-stats-likes">
			<div class="form-title-edit"></div>
			<div class="form-print"></div>
			<span class="liked-by like-action d-flex align-items-center">
				<svg class="icon icon-sm like-icon pointer">
					<use href="#icon-heart"></use>
				</svg>
			</span>
		</div>
		{% endif %}
	</div>
</div>
<div class="sidebar-section sidebar-rating hide border-bottom">
	<div style="position: relative;">
		<a class="strong badge-hover">
			<span>{%= __("Feedback") %}</span>
		</a>
	</div>
	<div class="rating-icons"></div>
</div>
<div class="sidebar-section hidden border-bottom">
	{% if (frappe.help.has_help(doctype)) { %}
	<div>
		<a class="help-link list-link" data-doctype="{{ doctype }}">{{ __("Help") }}</a>
	</div>
	{% } %}
</div>
<div class="sidebar-section user-actions hidden border-bottom">
	<div class="form-sidebar-items user-actions-header">
		<div class="form-sidebar-label">
			{%= frappe.utils.icon("link-2") %}
			<span class="ellipsis">{%= __("Links") %}</span>
		</div>
	</div>
	<div class="user-actions-list"></div>
</div>
<div class="sidebar-section form-assignments">
	<div>
		<span class="form-sidebar-items">
			<span class="add-assignment-label form-sidebar-label">
				{%= frappe.utils.icon("users") %}
				<span class="ellipsis">{%= __("Assign") %}</span>
			</span>
			<button class="add-assignment-btn btn btn-link icon-btn">
				<svg class="es-icon icon-sm"><use href="#es-line-add"></use></svg>
			</button>
		</span>
		<div class="assignments"></div>
	</div>
</div>
<div class="sidebar-section form-attachments">
	<div class="attachments-actions">
		<span class="form-sidebar-items">
			<span>
				<a class="pill-label ellipsis form-sidebar-label explore-link">
					{%= frappe.utils.icon("paperclip") %}
					{%= __("Attachments") %}
				</a>
			</span>
			<button class="add-attachment-btn btn btn-link icon-btn">
				<svg class="es-icon icon-sm"><use href="#es-line-add"></use></svg>
			</button>
		</span>
	</div>
	<a class="show-all-btn hidden" href="">
		<span class="pill-label ellipsis">
			{%= __("Show All") %}
		</span>
	</a>
</div>
<div class="sidebar-section form-tags">
	<div>
		<span class="form-sidebar-items">
			<div class="form-sidebar-label">
				{%= frappe.utils.icon("tag") %}
				<span class="tags-label ellipsis">{%= __("Tags") %}</span>
			</div>
		</span>
	</div>
</div>
<div class="sidebar-section form-shared border-bottom">
	<div>
		<span class="form-sidebar-items">
			<span class="share-label form-sidebar-label">
				{%= frappe.utils.icon("share-2") %}
				<span class="ellipsis">{%= __("Share") %}</span>
			</span>
			<button class="share-doc-btn btn btn-link icon-btn">
				<svg class="es-icon icon-sm"><use href="#es-line-add"></use></svg>
			</button>
		</span>
		<div class="shares"></div>
	</div>
</div>
<div class="sidebar-section followed-by-section hidden">
	<div class="sidebar-label followed-by-label">
		{%= __("Followed by") %}
	</div>
	<div class="followed-by"></div>
	<div class="document-follow">
		<a class="badge-hover follow-document-link hidden">
			{%= __("Follow") %}
		</a>
		<a class="badge-hover unfollow-document-link hidden">
			{%= __("Unfollow") %}
		</a>
	</div>
</div>
<div class="sidebar-section hidden">
	<a><li class="indicator blue auto-repeat-status" style="display: none;"></li></a>
</div>
<div class="sidebar-section text-muted pt-3">
	<ul class="list-unstyled sidebar-menu text-muted">
		<li class="modified-by"></li>
		<li class="created-by"></li>
		<li class="pageview-count"></li>
	</ul>
</div>

{% if(frappe.get_form_sidebar_extension) { %}
	{{ frappe.get_form_sidebar_extension() }}
{% } %}
`;
